import { Settings2 } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@easyflow/ui-master/components/ui/card';
import { Badge } from '@easyflow/ui-master/components/ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@easyflow/ui-master/components/ui/table';
import type { RuntimeConfigItem } from '@easyflow/shared';

interface Props {
  items: RuntimeConfigItem[];
  desiredSource: string;
}

export function RuntimeConfigCard({ items, desiredSource }: Props) {
  const driftCount = items.filter((i) => i.drift).length;
  const nodes = items[0]?.values_by_node.map((n) => n.node) ?? [];

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Settings2 className="h-5 w-5 text-purple-500" />
          Configurazione runtime
          {driftCount > 0 && (
            <Badge variant="outline" className="bg-rose-500/15 text-rose-700 border-rose-300">
              {driftCount} drift
            </Badge>
          )}
        </CardTitle>
        <CardDescription>
          Confronto pg_settings per nodo vs desired ({desiredSource})
        </CardDescription>
      </CardHeader>
      <CardContent>
        {items.length === 0 ? (
          <p className="text-sm text-muted-foreground italic">Nessun parametro disponibile</p>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Parametro</TableHead>
                {nodes.map((n) => <TableHead key={n}>{n}</TableHead>)}
                <TableHead>Desired</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {items.map((it) => (
                <TableRow key={it.name} className={it.drift ? 'bg-rose-500/5' : ''}>
                  <TableCell className="font-mono text-xs font-semibold">{it.name}</TableCell>
                  {it.values_by_node.map((nv) => {
                    const driftHere = it.desired !== null && nv.reachable && nv.value !== null && nv.value !== it.desired;
                    return (
                      <TableCell key={nv.node} className="font-mono text-xs">
                        {!nv.reachable ? (
                          <span className="text-muted-foreground/70 italic" title={nv.error}>unreachable</span>
                        ) : nv.value === null ? (
                          <span className="text-muted-foreground/70">—</span>
                        ) : (
                          <span className={driftHere ? 'text-rose-600 font-semibold' : 'text-foreground dark:text-muted-foreground/60'}>
                            {nv.value}
                          </span>
                        )}
                      </TableCell>
                    );
                  })}
                  <TableCell className="font-mono text-xs text-muted-foreground">
                    {it.desired ?? <span className="italic text-muted-foreground/70">—</span>}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}
